import * as _API from "../API/index";
import { YodiBoardConfiguration } from "./ModelViews";
//----------------------------------------------- 
export module DashboardStructs {
  export enum CyanServers {
    TCyan = 0,
    Cyan = 1,
    Localhost = 2,
    Dev4Cyan = 3,
    Dev6Cyan = 4,
    Dev5Cyan = 5
  }
  export interface DashboardGenericResp {
    ErrorMsg: string;
    Success: boolean;
  }
  export interface DashboardView {

    /**
     * The JSON form of dashboard settings.
     */
    JsonDashboardSettings: string;

    /**
     * The json form of widgets
            The server (C#) can't deserialized the widgets
     */
    JsonViewWidgets: string;

    /**
     * Each dashboard view have a unique key
     */
    Key: string;

    /**
     * The timestamp of the last modification
     */
    Timestamp: Date;

    /**
     * Each dashboard have assigned a unique WebModule 
            that is handling the widgets as things
     */
    WebModuleKey: string;
  }
  export interface MacroInfo {
    /**
     * The connection string for the query.
            This is valid only in design mode.
     */
    ConnectionString: string;

    /**
     * The developer that have make the change
     */
    Developer: string;

    /**
     * Macro is active
     */
    Enabled: boolean;

    /**
     * Macro guid
     */
    Guid: string;

    /**
     * Script to handling results from server
     */
    JsHandlingScript: string;

    /**
     * Script for preparation of parameters
     */
    JsPrepScript: string;

    /**
     * Macro type MySQL, Influx, Rest ...
     */
    MacroType: Macros.MacroScriptType;

    /**
     * Script that the server is going to run.
            This is valid only in design mode.
     */
    QueryScript: string;

    /**
     * Settings for the json
     */
    SettingsJson: string;

    /**
     * Last modify timestamp
     */
    Timestamp: Date;

    /**
     * Macro version
     */
    Version: number;
  }
  export interface PublicSharing {
    Enabled: boolean;
    PublicKey: string;
  }
  export interface YodiBoard {
    VersionHash: string;
    CyanServer: DashboardStructs.CyanServers;
    Description: string;
    FormatVersion: string;
    Id: string;
    IsDomainShared: boolean;
    IsEditable: boolean;
    IsShareable: boolean;
    IsUserOwner: boolean;

    /**
     * Json form of json alerts for the specific board
     */
    JsonAlerts: string;

    /**
     * Json form of localization of the board
     */
    JsonLocalization: string;

    /**
     * YodiBoard settings
            JSON string of a  object.
     */
    JsonSettings: string;

    /**
     * Theme in json format
     */
    JsonTheme: string;
    LastModify: Date;

    /**
     * List with active macros of the board
     */
    Macros: DashboardStructs.MacroInfo[];
    Name: string;
    NodeKey: string;

    /**
     * This is valid only in loading time
     */
    NodeSecret: string;

    /**
     * Number of decorative widgets
     */
    NumberOfDecorativeWidgets: number;

    /**
     * Number of non-decorative widgets
     */
    NumberOfNonDecorativeWidgets: number;
    OwnerEmail: string;

    /**
     * This is not valid in basic loading
     */
    Pages: DashboardStructs.YodiPage[];

    /**
     * Public Sharing info.
            If is null then we don't support it
     */
    PublicSharing: DashboardStructs.PublicSharing;

    /**
     * this is valid only in loading time
     */
    WebModuleKey: string;
  }
  export interface YodiBoardAddResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
    Board: DashboardStructs.YodiBoard;
  }
  export interface YodiBoardGetMacroHistoryResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
    History: DashboardStructs.MacroInfo[];
  }
  export interface YodiBoardGetPublicSharingResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
    Board: DashboardStructs.YodiBoard;
    ServersInfo: { [key: number]: WebApps.CyanServerInfo };
  }
  export interface YodiBoardGetResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
    MyBoards: DashboardStructs.YodiBoard[];
    MyDomainBoards: DashboardStructs.YodiBoard[];
    SharedBoards: DashboardStructs.YodiBoard[];
  }
  export interface YodiBoardGetSharedListResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
    Info: DashboardStructs.YodiBoardUserInfo[];
  }
  export interface YodiBoardGetVersionsResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
    VersionHash: string;
  }
  export interface YodiBoardLoadDeletedResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
    Pages: DashboardStructs.YodiPage[];
  }
  export interface YodiBoardLoadReq {
    Id: string;

    /**
     * Load the board in view mode 
            Avoid the sending of macros sql info
     */
    IsViewMode: boolean;
  }
  export interface YodiBoardLoadResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
    Board: DashboardStructs.YodiBoard;
  }
  export interface YodiBoardPublicSharingInfo {
    BoardId: string;
    PublicKey: string;
  }
  export interface YodiBoardSaveResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
    Id: string;

    /**
     * Note: These `YodiPage` instances do not contain all the information, only `Id` and `Version` fields are valid.
     */
    Pages: DashboardStructs.YodiPage[];
  }
  export interface YodiBoardSetSharedListReq {
    BoardId: string;
    Info: DashboardStructs.YodiBoardUserInfo[];
  }
  export interface YodiBoardSetSharedListResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
    Info: DashboardStructs.YodiBoardUserInfo[];
  }
  export interface YodiBoardUpdateConfResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
    Board: DashboardStructs.YodiBoard;
  }
  export interface YodiBoardUpdateMacroReq {
    /**
     * The ID of the yodiboard that we update localization
     */
    BoardId: string;

    /**
     * Deleted macros
     */
    DeleteMacro: DashboardStructs.MacroInfo[];

    /**
     * Updated macros
     */
    UpdateMacro: DashboardStructs.MacroInfo[];
  }
  export interface YodiBoardUpdateMacroResp extends Yodiwo.Web.Library.ModelViews.GenericResp { }
  export interface YodiBoardUpdatePagesReq {
    /**
     * The ID of the yodiboard that we update pages
     */
    BoardId: string;

    /**
     * List with pages that we request delete
     */
    DeletedPagesID: string[];

    /**
     * The localization dictionary in json format
     */
    JsonLocalization: string;

    /**
     * List with pages that we request undelete
     */
    UndeletePages: string[];

    /**
     * List with updated pages
     */
    UpdatedPages: DashboardStructs.YodiPage[];
  }
  export interface YodiBoardUpdateThemeReq {

    /**
     * The ID of the yodiboard that we update theme
     */
    BoardId: string;

    /**
     * JSON theme
     */
    ThemeJson: string;
  }
  export interface YodiBoardUpdateThemeResp extends Yodiwo.Web.Library.ModelViews.GenericResp { }
  export interface YodiBoardUserInfo {
    FromDB: boolean;
    IsDomainShared: boolean;
    IsEditable: boolean;
    IsOwner: boolean;
    IsPending: boolean;
    IsShareable: boolean;
    UserDomain: string;
    UserEmail: string;
    UserId: string;
    YodiBoardId: string;
  }
  export interface YodiPage {
    Deleted: boolean;
    Id: string;
    JsonDashboardSettings: string;
    JsonViewWidgets: string;
    Timestamp: Date;
    Version: number;
    WebModuleKey: string;
  }
}
//----------------------------------------------- 
export module Macros {
  export module ServerAutoParameters {
    export const UserEmail: string = "__UserEmail__";
  }
  export enum MacroScriptType {
    RestAPI = 1,
    MySQL = 2,
    Influx = 3,
    Javascript = 4,
    Flux = 5
  }
  export interface ExecuteSQLReq {

    /**
     * Inline connection string for development phase
     */
    ConnectionStr?: string;

    /**
     * The id of the saved Macro, null if is not saved yet (design phase)
     */
    MacroID?: string;

    /**
     * The version of macro that we are going to execute
     */
    MacroVersion?: number;

    /**
     * An id for the project that is include this macro.
            This is per application id and is something that the external project define.
     */
    ProjectID: string;

    /**
     * The actual query
     */
    Query?: string;

    /**
     * The parameters of the query
     */
    QueryParameters: System.Collections.Generic.KeyValuePair<string, any>[][];
  }
  export interface ExecuteSQLResp extends Yodiwo.Web.Library.ModelViews.GenericResp {

    /**
     * Results in string json format
     */
    JsonResults: string[];
  }
}
//----------------------------------------------- 
export module System.Collections.Generic {
  export interface KeyValuePair<TKey, TValue> {
    Key: TKey;
    Value: TValue;
  }
}
//----------------------------------------------- 
export module WebApps {
  export enum DomainUserRole {
    User = 0,
    Developer = 1,
    Admin = 2
  }
  export interface AvatarInfoView {
    Large: string;
    Normal: string;
    Small: string;
  }
  export interface CyanServerInfo {
    CyanURL: string;
    Id: number;
    Name: string;
    URL: string;
    WebSocketURL: string;
  }
  export interface DomainBoardInfo {
    BoardId: string;
    NodeKey: string;
    BoardThemeJSON: string;
    BoardSettingsJSON: string;
    BoardSettings: YodiBoardConfiguration;
  }
  export interface CookiesConsentInfo {
    description: string;
    moreInfo: string;
  }
  export interface DomainInfo {
    UserRole: WebApps.DomainUserRole;
    IsOneBoardSolution: boolean;
    PredefinedLoadingBoardInfo: WebApps.DomainBoardInfo;
    CookiesJSON: string;
  }
  export interface UserInfoResp {
    DomainInfo: WebApps.DomainInfo;
    LoggedIn: boolean;
    ServersInfo: { [key: number]: WebApps.CyanServerInfo };
    Settings: WebApps.UserSettings;
    UserInfo: WebApps.UserInfoView;
  }
  export interface UserInfoView {
    AvatarUri: WebApps.AvatarInfoView;
    Domain: string;
    Email: string;
    FirstName: string;
    LastName: string;
  }
  export interface UserSettings {
    DefaultLoadingBoardId: string;
  }
}
//----------------------------------------------- 
export module Yodiwo.Web.Library.ModelViews {
  export interface GenericResp {
    ErrorStr: string;
    IsSuccess: boolean;
  }
}